// extracted by mini-css-extract-plugin
export default {"root":"SuspiciousDialog__root--2DpK3","title":"SuspiciousDialog__title--7kyDn","icon":"SuspiciousDialog__icon--27oza"};